<template>
  <div class="order-productInfo">
    <div v-if="detailData.productInfo">
      <p class="o-title">商品信息</p>
      <div class="order-wrapper" v-for="(product, productIndex) in detailData.productInfo" :key="productIndex">
        <div class="order-title-wrapper">
          <p class="or-title flex-title">
            <span class="or-first">商品详情</span>
            <span class="or-second">商品金额</span>
          </p>
        </div>
        <div class="order-content-wrapper">
          <div class="or-con or-first or-con-left">
            <!-- 课程信息 -->
            <div class="or-coupon" v-if="product.couponInfo">
              <div class="money-card-left">
                <div class="money-card-ticket">
                  <p class="money-card-money">
                    <span class="money-card-sign">￥</span>
                    {{ product.couponInfo.discount.replace(/￥|¥/gi, '') }}
                  </p>
                  <p class="money-card-desc">{{ product.couponInfo.threshold }}</p>
                </div>
                <div class="money-card-content">
                  <p class="money-card-name">{{ product.productName }}</p>
                  <p class="money-card-time">{{ product.couponInfo.receive_stime }} - {{ product.couponInfo.receive_etime }}</p>
                </div>
              </div>
              <div class="money-card-right">
                <p class="money-card-price">￥{{ product.resale }}</p>
                <p class="money-card-num">x {{ product.productNum }}</p>
              </div>
            </div>
            <div class="or-course" v-else>
              <p class="course-name">
                <!-- 换购icon -->
                <span class="presell-icon" v-if="product.productTag && product.productTag != ''">{{ product.productTag }}</span>
                <!-- 次卡和预购卡订单不可以点击名称跳转，不显示学科icon -->
                <span v-if="product.productType != 202 && product.productType != 230 && product.identityName" class="tag course-tag">{{ product.identityName }}</span>
                <span class="text">
                  <span v-if="product.productType == 202 || product.productType == 230">
                    {{ product.productName }}
                  </span>
                  <a v-else :href="'https:\/\/online.xueersi.com\/kc\/' + product.productId" target="_blank">{{ product.productName }}</a>
                </span>
              </p>
              <p class="course-time">
                {{ product.showName }}
              </p>
              <p class="course-teacher">
                <span class="teach" v-if="product.mainTeacherName">
                  授课：
                  <em class="black">{{ product.mainTeacherName }}</em>
                </span>
                <span class="teach" v-if="product.foreignTeacherName">
                  外教：
                  <em class="black">{{ product.foreignTeacherName }}</em>
                </span>
              </p>
            </div>
          </div>
          <div class="or-con or-second">
            <p>¥{{ product.resale }}</p>
          </div>
        </div>
        <div class="order-welfare" v-if="product.giveawayInfos && product.giveawayInfos.length > 0">
          <div class="welfare-icon-wrapper"><em class="welfare-icon">福利</em></div>
          <div class="welfare-detail">
            <p class="welfare-detail-p" v-for="(welfare, welfareIndex) in product.giveawayInfos" :key="welfareIndex">
              <span class="welfare-text">{{ welfare.productName }} ×{{ welfare.productNum }}</span>
              <span class="welfare-status">{{ welfare.logisticStatusDesc }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['detailData']
}
</script>
<style lang="less" scoped>
.order-productInfo {
  .order-wrapper {
    .order-content-wrapper {
      align-items: flex-start;
    }
  }
}
.o-title {
  font-weight: bolder;
  padding-bottom: 10px;
}
.order-wrapper {
  width: 100%;
  margin-bottom: 15px;
  border: solid 1px #e0e0e0;
  color: #666666;
  .order-title-wrapper,
  .order-content-wrapper {
    .or-first {
      display: inline-block;
      width: 85%;
    }
    .or-second,
    .or-third,
    .or-forth {
      display: inline-block;
      width: 136px;
      flex-shrink: 0;
    }
  }
  .order-title-wrapper {
    padding: 10px 0;
    font-size: 12px;
    border-bottom: solid 1px #e0e0e0;
    background: #f5f5f5;
    .or-first,
    .or-second,
    .or-third,
    .or-forth {
      text-align: center;
    }
    .or-warning {
      height: 30px;
      line-height: 30px;
      .orange {
        color: #f0773c;
      }
    }
    .flex-title {
      display: flex;
    }
  }
  .course-tag {
    display: inline-block;
    min-width: 10px;
    padding: 1px;
    font-size: 12px;
    line-height: 1;
    vertical-align: baseline;
    white-space: nowrap;
    text-align: center;
    border-radius: 2px;
    background-color: transparent;
    border: 1px solid #f13232;
    color: #f13232;
    margin-bottom: 4px;
  }
  .welfare-icon {
    padding: 1px 8px 2px 8px;
    border-radius: 2px;
    margin-right: 5px;
    vertical-align: top;
    color: #ef3232;
    border: 1px solid #ef3232;
  }
  .order-content-wrapper {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    align-items: center;
    font-size: 12px;
    &:after {
      content: '';
      display: block;
      clear: both;
    }
    .or-con-left {
      border-right: 1px solid #dcdcdc;
    }
    .or-con {
      float: left;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      -ms-box-sizing: border-box;
      box-sizing: border-box;
      & > div:last-child {
        border-bottom: none;
      }
      .or-coupon {
        font-weight: 400;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 12px 44px 12px 20px;
        .money-card-left {
          width: 700px;
          display: flex;
          flex-direction: row;
          align-items: center;
          .money-card-ticket {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-right: 12px;
            width: 80px;
            height: 80px;
            background-color: rgba(224, 158, 39, 0.06);
            color: #e02727;
          }
          .money-card-money {
            font-size: 23px;
          }
          .money-card-sign {
            font-size: 13px;
          }
          .money-card-desc {
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            margin-top: 4px;
            font-size: 12px;
          }
          .money-card-content {
          }
          .money-card-name {
            font-weight: 500;
            font-size: 14px;
            color: #333;
          }
          .money-card-time {
            margin-top: 36px;
            font-size: 12px;
            color: #666;
          }
        }
        .money-card-right {
          .money-card-price {
            margin-left: -3px;
            font-size: 12px;
            color: #666;
          }
          .money-card-num {
            margin-top: 12px;
            font-size: 12px;
            color: #666;
          }
        }
      }
      .or-course {
        padding: 20px;
        border-bottom: solid 1px #e0e0e0;
        .course-name {
          margin-bottom: 5px;
          .text {
            color: #333333;
            a {
              font-size: 14px;
              color: #333333;
              &:hover {
                color: #666666;
              }
            }
          }
          .presell-icon {
            background: #f0773c;
            line-height: 16px;
            font-size: 12px;
            color: #fff;
            border-radius: 2px;
            display: inline-block;
            padding: 0 4px;
            margin-right: 6px;
          }
        }
        .course-time {
          margin-bottom: 5px;
        }
        .course-teacher {
          margin-bottom: 0;
          .coach {
            margin-left: 15px;
          }
        }
      }
    }
    .or-first {
    }
    .or-second {
      padding: 20px 0;
      & > p {
        text-align: center;
      }
    }
    .or-third {
      padding: 20px 0;
      & > p {
        text-align: center;
      }
      a {
        color: #333333;
        &:hover {
          color: #666666;
        }
      }
    }
    .or-forth {
      padding: 20px 0;
      & > p {
        text-align: center;
      }
      a {
        color: #333333;
        &:hover {
          color: #f13232;
        }
      }
    }
  }
  .order-welfare {
    padding: 0 0 0 20px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    border-top: solid 1px #e0e0e0;
    .welfare-icon-wrapper {
      width: 6%;
      display: inline-block;
      padding-top: 20px;
    }
    .welfare-detail {
      width: 93%;
      display: inline-block;
      & > p:last-child {
        border-bottom: none;
      }
    }
    .welfare-detail-p {
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-bottom: solid 1px #e0e0e0;
      .welfare-status {
        float: right;
        margin-right: 35px;
      }
    }
  }
  .black {
    color: #333333;
  }
  .bd-bottom {
    border-bottom: solid 1px #e0e0e0;
  }
  .bd-top {
    border-top: solid 1px #e0e0e0;
  }
  .no-border {
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// module/order/src/components/sub/productInfo.vue